import React, { useState } from "react";
import Pricingsectionparticular from "./Pricingsectionparticular";

function Promotionspricingdetails({ feature, onBack }) {

    const [showBackButton, setShowBackButton] = useState(true);

    return (
        <div
            style={{
                padding: "20px",
                borderRadius: "12px",
            }}
        >
            {showBackButton && (
                <button
                    onClick={onBack}
                    style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "6px",
                        padding: "7px 14px",
                        marginBottom: "15px",
                        background: "#ff7a00",
                        color: "#fff",
                        border: "none",
                        borderRadius: "20px",
                        fontSize: "13px",
                        fontWeight: "600",
                        cursor: "pointer",
                    }}
                >
                    ← Back
                </button>
            )}

            <Pricingsectionparticular
                feature={feature}
                hideParentBack={() => setShowBackButton(false)}
                showParentBack={() => setShowBackButton(true)}
            />
        </div>
    );
}

export default Promotionspricingdetails;